import { useFormikContext } from "formik";
import ReviewSubmitTable from "../../Reuseables/Tables/ReviewSubmitTable";
import { Project } from "../../../types/project";

export default function ReviewAndSubmitStep() {
  const { values } = useFormikContext();

  return <ReviewSubmitTable values={values as Project} />;
}
